import { defineMessages } from "react-intl";

const messages = defineMessages({
  title: {
    defaultMessage: "Customize list",
    id: "p+HM56",
    description: "header",
  },
  columnSubheader: {
    defaultMessage: "Column settings",
    id: "dS+SOT",
    description: "header",
  },
  columnLabel: {
    defaultMessage: "Selected columns",
    id: "IHtOda",
    description: "input label",
  },
});

export default messages;
